import React, {Component} from 'react';
import Loading from './Loading';
import Pagination from './Pagination';
import {_Alert, variable, _post, _getToken, _isLogin} from './Function';
import '../css/Deposit.css';

class LoanTransaction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.match.params.id,
            loadingShow: false,
            data: [],
            guarantee: [],
            transaction: [],
            currentPage: 1,
            rowPerPage: 13,
            is_guarantee: true,
            is_trans: true
        }
        _isLogin().then(value => {
            if (value) this.getLoanTransaction();
        });
    }

    fallBack = (page) => {
        this.setState({currentPage: page});
    }

    getLoanTransaction() {
        let param = {token: _getToken(), platform: variable().platform, loan_id: this.state.id};
        _post('get.loan.transaction.php', param)
            .then(res => {
                console.log('res', res)
                if (res.data.responseText === 101) {
                    localStorage.clear();
                    _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                }
                this.setState({
                    loadingShow: false,
                    data: res.data.data,
                    is_guarantee: (res.data.guarantee) ? true : false,
                    is_trans: (res.data.transaction) ? true : false,
                    transaction: res.data.transactionData,
                    guarantee: res.data.guaranteeData
                });
                // console.log('state', this.state)
            }).catch(err => {
                console.log(err)
            this.setState({loadingShow: false});
            _Alert('error');
        });
    }

    sum = (txt1, txt2) => {
        let val1 = Number(txt1.replace(',', ''));
        let val2 = Number(txt2.replace(',', ''));
        return val1 + val2;
    }

    transaction = () => {
        const {rowPerPage, currentPage, transaction} = this.state;
        const indexOfLastTodo = currentPage * rowPerPage;
        const indexOfFirstTodo = indexOfLastTodo - rowPerPage;
        const currentTodos = transaction.slice(indexOfFirstTodo, indexOfLastTodo);

        return (
            <div>
                <table className="table table-deposit">
                    <thead>
                    {
                        (this.state.transaction.length > 0) ?
                            <tr>
                                <th scope="col" width="27%" className="th-title">วันที่ทำรายการ</th>
                                <th scope="col" width="20%" className="th-title">รายการ</th>
                                <th scope="col" width="10%" className="th-title">งวด</th>
                                <th scope="col" width="10%" className="th-title">เงินต้น</th>
                                <th scope="col" width="10%" className="th-title">ดอกเบี้ย</th>
                                <th scope="col" width="15%" className="th-title">รวม</th>
                            </tr>
                            :
                            null
                    }
                    </thead>
                    <tbody>
                    {
                        currentTodos.map((transaction, index) => (
                            <tr key={index}>
                                <td className="th-title">{transaction.payment_date}</td>
                                <td className="th-title">{transaction.pay_desc}</td>
                                <td className="th-title">{transaction.period_count}</td>
                                <td className="th-title">{transaction.payment}</td>
                                <td className="th-title">{transaction.interest}</td>
                                <td className="th-body">
                                    <span className="row-balance">
                                        { this.sum(transaction.payment, transaction.interest).toLocaleString('en', {maximumFractionDigits: 2, minimumFractionDigits: 2}) } บาท
                                    </span>
                                </td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table>

                <div className="mobile-content">
                    {
                        currentTodos.map((transaction, index) => (
                            <div key={index} className={(index === 0) ? 'deposit-loop is-first' : 'deposit-loop'}>
                                <div className="deposit-row">

                                    <div className="deposit-row-first"><span
                                        className="text-title">วันที่ทำรายการ : </span><span
                                        className="text-desc">{transaction.payment_date}</span></div>
                                    <div className="deposit-row-second"><span
                                        className="text-title">รายการ : </span><span
                                        className="text-desc">{transaction.pay_desc}</span>
                                    </div>
                                    <div className="deposit-row-third">
                                        <span className="text-title">งวดที่ : </span>
                                        <span className="text-desc type-desc">
                                            {transaction.period_count}</span>
                                    </div>
                                    <div className="deposit-row-third">
                                        <span className="text-title">เงินต้น : </span>
                                        <span className="text-desc type-desc">
                                            {transaction.payment}  บาท</span>
                                    </div>
                                    <div className="deposit-row-fourt">
                                        <span className="text-title">ดอกเบี้ย : </span>
                                        <span className="text-desc">
                                            {transaction.interest} บาท
                                        </span>
                                    </div>
                                    <div className="deposit-row-fourt">
                                        <span className="text-title">รวม : </span>
                                        <span className="text-desc">
                                            { this.sum(transaction.payment, transaction.interest).toLocaleString('en', {maximumFractionDigits: 2, minimumFractionDigits: 2}) } บาท
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>

                {(this.state.transaction.length > this.state.rowPerPage) ?
                    <Pagination onSelectPage={this.fallBack} rowPerPage={this.state.rowPerPage}
                                lengths={this.state.transaction.length}/> : null}
            </div>)
    }

    guaranteeRender = () => {
        const { guarantee } = this.state;

        return (
            <div>
                {
                    guarantee.map((person, index) => (
                        <div key={index}>
                            <span className="text-title"> { person.name } </span>
                        </div>
                    ))
                }
            </div>
        )
    }

    render() {
        return (
            <div>
                <Loading show={this.state.loadingShow}/>

                {/* info */}
                <div className="card">
                    <div className="card-title">
                        <div className="card-icon"><i className="fas fa-dollar-sign"></i></div>
                        <div className="card-title-text">เงินกู้</div>
                    </div>
                    <div className="card-content card-info">
                        <div className="loan-row">
                            <div className="loan-row-first"><span className="text-title">เลขสัญญา : </span><span
                                className="text-desc">{this.state.data.contract_number}</span></div>
                            <div className="loan-row-second"><span className="text-title">รายการ : </span><span
                                className="text-desc">{this.state.data.loan_type}</span></div>
                        </div>
                        <div className="loan-row">
                            <div className="loan-row-third"><span className="text-title">วงเงินกู้ : </span><span
                                className="text-desc type-desc">{this.state.data.loan_amount} บาท</span></div>
                            <div className="loan-row-fourt"><span className="text-title">จำนวนงวด : </span><span
                                className="text-desc">{this.state.data.period_amount}</span></div>
                        </div>
                        <div className="loan-row">
                            <div className="loan-row-third"><span className="text-title">ชำระต่อเดือน : </span><span
                                className="text-desc type-desc">{this.state.data.pay_per_month}</span></div>
                            <div className="loan-row-fourt"><span className="text-title">คงเหลือ : </span><span
                                className="text-desc">{this.state.data.loan_amount_balance} บาท</span></div>
                        </div>
                    </div>
                </div>

                {/* guarantee */}
                <div className="card">
                    <div className="card-title">
                        <div className="card-icon"><i className="fas fa-user-tag"></i></div>
                        <div className="card-title-text">ผู้ค้ำประกัน</div>
                    </div>
                    <div className="card-content">
                        {
                            (this.state.is_guarantee) ?
                                this.guaranteeRender()
                                :
                                <div className="no-data">ไม่พบผู้ค้ำประกัน</div>
                        }
                    </div>
                </div>

                {/* transaction */}
                <div className="card">
                    <div className="card-title">
                        <div className="card-icon"><i className="fas fa-exchange-alt"></i></div>
                        <div className="card-title-text">รายการเคลื่อนไหว</div>
                    </div>
                    <div className="card-content">
                        {
                            (this.state.is_trans) ?
                                this.transaction()
                                :
                                <div className="no-data">ไม่พบรายการเคลื่อนไหว</div>
                        }
                    </div>
                </div>

            </div>
        )
    }
}

export default LoanTransaction;
